import React from 'react';
import {Flex, Text, Input, Button} from '@priority-software/priority-style-react';
import texts from '../texts';
import styles from '../EmailVerification.module.scss';

type VerificationContentProps = {
    email: string;
    setEmail: (value: string) => void;
    isBtnDisabled: boolean;
    submitEmail: () => void;
};

export const VerificationContent = ({
    email,
    setEmail,
    isBtnDisabled,
    submitEmail
}: VerificationContentProps) => {
    return (
        <Flex direction="column" componentClasses={styles.content}>
            <Text>
                <Text tag="span" skin="paragraph-2">
                    {texts.firstMessageDescP1}
                </Text>
                &nbsp;
                <Text tag="span" skin="paragraph-2">
                    {texts.firstMessageDescP2}
                </Text>
            </Text>
            <Input
                type="email"
                value={email}
                onChange={setEmail}
                label={texts.preInputText}
                placeholder={texts.emailPlaceholder}
                componentClasses={styles.input}
                required
            />
            <Button
                size="medium"
                disabled={isBtnDisabled}
                componentClasses={styles.footerBtn}
                onClick={submitEmail}
            >
                {texts.verifyBtn}
            </Button>
        </Flex>
    );
};
